import React, { memo } from 'react';
import * as S from './styles';
import * as FooterStyle from '../../styles';
import { Column, Page } from '../../types';

interface Props {
  infoPageColumns: Column[];
  numberOfColumns: number;
  className?: string;
}

const InfoPages = ({ infoPageColumns, numberOfColumns, className }: Props) => (
  <div className={className}>
    {infoPageColumns.map((column: Column) => {
      return (
        <S.Column
          key={`column-${column.title}`}
          numberOfColumns={numberOfColumns}
        >
          <FooterStyle.ColumnTitle>{column.title}</FooterStyle.ColumnTitle>
          <S.InfoPagesList>
            {column.pages.map((page: Page) => {
              return (
                <S.ListItem key={`${page.title}-${page.id}`}>
                  <S.Link href={page.pathName}>{page.title}</S.Link>
                </S.ListItem>
              );
            })}
          </S.InfoPagesList>
        </S.Column>
      );
    })}
  </div>
);

export default memo(InfoPages);
